import { Component, OnInit } from '@angular/core';
import { SharedService, betticket, RetailBalanceRpt, MyBetsSharedService, User, LottoBetpanelService, ConfigService } from 'baseline-lib';
import { NavController, LoadingController } from 'ionic-angular';
import { DatePipe } from '@angular/common';
import { Global } from '../../../../global/global';
import { HomePage } from '../../../home/home/home';
import { CustomToast } from '../../services/custom-toast';
import { IMyDpOptions } from 'mydatepicker';

/**
 * Generated class for the BetHistoryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'bet-history',
  templateUrl: 'bet-history.html'
})
export class BetHistoryComponent implements OnInit{

  fromDate: any;
  toDate: any;
  currentTime = new Date();
  _betTicketList: any = [] = [];
  _ticketList: betticket[] = [];
  current: number = -1;
  reportFlag:boolean = false;
  myDatePickerOptions: IMyDpOptions = {
    inline: false,
    editableDateField: false,
  }
  
  constructor(public navCtrl : NavController, public _sharedServices : SharedService,
    public globalData : Global,public toast:CustomToast,public _configService : ConfigService,
    public loadingCtrl: LoadingController, public datepipe : DatePipe, public _sharedService: SharedService,
    public _myBetsSharedService :  MyBetsSharedService, public _lottoBetpanelService: LottoBetpanelService) {
    console.log('Hello BetHistoryComponent Component');
    this.fromDate = this.toDate = { date: { year: this._sharedService.getServerTime().getFullYear(), month: this._sharedService.getServerTime().getMonth() + 1, day: this._sharedService.getServerTime().getDate() }, jsdate: new Date() };
  }

  ngOnInit()
  {
    this._myBetsSharedService._clearHistory.subscribe(typeid => {
      this._betTicketList = this._ticketList = [];      
      // this.fromDate = this.currentTime.toISOString();
      // this.toDate = this.currentTime.toISOString();
    });
    
  }

  getBetReport(){
    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });

    this._ticketList = [];
    let authuser = this.globalData.authUser;
    if (authuser == null || authuser == undefined) {
      loader.dismiss();
      this.toast.showError("Login to continue ...!");
    }
    this.current = -1;
    this._betTicketList = [];

    if (this.fromDate == null || this.toDate == null) {
      this.toast.showError("Enter Start and End Date....!");
      return false;
    } else if (this.fromDate.jsdate > this.toDate.jsdate) {
      this.toast.showError("End Date should be greater than Start date...!");
      return false;
    }
    let resultReq = new RetailBalanceRpt();
    resultReq.tokenId = authuser.tokenNo;
    resultReq.fd = this._sharedService.getFormatedDate(this.fromDate);
    resultReq.td = this._sharedService.getFormatedDate(this.toDate);
    loader.present();
    this._sharedServices.getBetTicketList(resultReq)
      .subscribe(
      data => {
        this.current = -1;
        loader.dismiss();
        if (data.tktli.length > 0) {
          this._betTicketList = [];
          var betTicketList: betticket[] = [];
          data.tktli.forEach(tkt => {
            var _betmodel = new betticket();
            // if (this._configService.getAppType() == AppType.retailer) {              
            // }
            _betmodel.parse(tkt);
            betTicketList.push(_betmodel);
          });
          this._ticketList = betTicketList;
          this.reportFlag = true;
          console.log(this._ticketList);
          // this.navCtrl.push(BetHistoryDetailPage,{"ticketList" : this._ticketList });
        }
        else {
          this._betTicketList = [];
          this.toast.showError("Records Not found ...!");
        }
      },
      error => {
        if(error.errorCode == 401){  // Logout
          this._ticketList = []
          this.current = -1;
          loader.dismiss();
          this._betTicketList = [];
          this.toast.showError("Please Login to continue!");
          localStorage.clear(); //logout;
          this.globalData.selectedMenu = "home";
          this.globalData.isLoggedIn = false;
          this.globalData.authUser = new User();
          this._lottoBetpanelService.clearallBetPanels();
          if(this._sharedServices.timerSub)
            this._sharedServices.timerSub.unsubscribe();
          if(!this._configService.isplayerLogin())
            this.navCtrl.setRoot(HomePage);
          this._sharedServices.loginSubject.next(false);
        }else{
          this.toast.showError(error.message);
        }
      }
      );

  }

  // showToast(msg){
  //   let toast = this.toastCtrl.create({
  //     message: msg,
  //     duration: 3000,
  //     position: 'bottom'
  //   });
  
  //   toast.onDidDismiss(() => {
  //     console.log('Dismissed toast');
  //   });
  
  //   toast.present();
  // }

}



// WEBPACK FOOTER //
// ./src/app/shared/bet-history/bet-history/bet-history.ts